import { createAsyncThunk } from "@reduxjs/toolkit";
import asyncInstance from "config/AsyncInstance";
import apiInstance from "config/axiosInstance";

export const GetAllPoyer = createAsyncThunk(
  "eligibilityCheckList/GetAllPoyer",
  async (_, { rejectWithValue }) => {
    try {
      const response = await asyncInstance.get("payerList");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const GetPatientDetails = createAsyncThunk(
  "eligibilityCheckList/GetPatientDetails",
  async (body, { rejectWithValue }) => {
    try {
      const response = await asyncInstance.post("patientFind", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const GetEligibilityCheckList = createAsyncThunk(
  "eligibilityCheckList/GetEligibilityCheckList",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(
        "insurance/eligibilityCheckList",
        body
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const GetPayerInsurance = createAsyncThunk(
  "eligibilityCheckList/GetPayerInsurance",
  async (body, { rejectWithValue }) => {
    try {
      const response = await asyncInstance.post("payerinsuranceFind", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const GetAllStatusEligibility = createAsyncThunk(
  "eligibilityCheckList/GetAllStatusEligibility",
  async (_, { rejectWithValue }) => {
    try {
      const response = await asyncInstance.post("allstatusList", {
        status_type: "eligibility",
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const GetSingleEligibilityData = createAsyncThunk(
  "eligibilityCheckList/GetSingleEligibilityData",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(
        `insurance/eligibilityCheckstatus/${id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const GetRequestJSONData = createAsyncThunk(
  "eligibilityCheckList/GetRequestJSONData",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(
        `insurance/eligibilityCheckreqDownload/${id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const GetResponseJSONData = createAsyncThunk(
  "eligibilityCheckList/GetResponseJSONData",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(
        `insurance/eligibilityCheckrespDownload/${id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
